<template>
    <div class="activity-item-content" v-if="showBodyText">

        <p v-if="shortBodyText">
            {{ shortBodyText }}
            <span class="activity-item-more">More + </span>
        </p>
        <p v-else v-text="currentReview.body"></p>

        <div class="activity-item-content-extra" v-if="shortBodyText">
            <p>
                {{ currentReview.body }}
                <span class="activity-item-less">Less -</span>
            </p>
        </div>

    </div>
</template>
<script>
export default {

    props: ['review'],

    data() {
        return {
            currentReview: this.review
        }
    },

    mounted() {
        $(document).on('click', '.activity-item-more', function () {
            var startHeight = $(this)
                .parents('.activity-item-content')
                .outerHeight()
            var endHeight

            $(this)
                .parents('.activity-item-content')
                .outerHeight(startHeight)
                .find('.activity-item-content-extra')
                .show()
            $(this)
                .parent()
                .hide()
            endHeight = $(this)
                .parents('.activity-item')
                .find('.activity-item-content-extra')
                .get(0).scrollHeight
            $(this)
                .parents('.activity-item-content')
                .outerHeight(endHeight)
        })

        $(document).on('click', '.activity-item-less', function () {
            var endHeight = $(this)
                .parents('.activity-item-content-extra')
                .prev()
                .outerHeight()
            $(this)
                .parents('.activity-item-content-extra')
                .prev()
                .show()
            $(this)
                .parents('.activity-item-content-extra')
                .hide()
            $(this)
                .parents('.activity-item-content')
                .outerHeight(endHeight)
        })
    },

    watch:{
        review(){
            this.currentReview = this.review
        }
    },

    computed: {
        shortBodyText() {
            return (this.currentReview.body && this.currentReview.body.length > 150) ? this.currentReview.body.substring(0, 150) : null
        },

        showBodyText() {
            return (this.currentReview.body != '' || this.currentReview.body != null)
        }
    }
}
</script>
